const curriedDemethodify = require("./curried-demethodify");
module.exports = (prototype, definition = {}) => {
    Object
        .entries(Object.getOwnPropertyDescriptors(prototype))
        .filter(([name, descriptor]) => name !== "constructor" && typeof descriptor.value === "function")
        .map(([name, descriptor]) => [name, descriptor.value])
        .forEach(([methodName, method]) => {
        definition[methodName] = curriedDemethodify(methodName, method);
    });
    return definition;
};
